import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import React, { useEffect } from "react";

const ServicePieChart = ({ data }) => {
  useEffect(() => {
    // Dispose previous instance if exists
    let root = am5.Root.new("servicePieChart");

    const chartData = data.map((item) => ({
      category: item.serviceName,
      value: item.count,
    }));

    // Set themes
    root.setThemes([am5themes_Animated.new(root)]);

    // Create chart
    let chart = root.container.children.push(
      am5percent.PieChart.new(root, {
        layout: root.verticalLayout,
      })
    );

    // Create series
    let series = chart.series.push(
      am5percent.PieSeries.new(root, {
        valueField: "value",
        categoryField: "category",
      })
    );

    // Set colors
    series
      .get("colors")
      .set("colors", [
        am5.color("#FF3A29"),
        am5.color("#FFB200"),
        am5.color("#4339F2"),
      ]);

    // Set data
    series.data.setAll(chartData);

    // Hide labels and ticks
    series.labels.template.set("visible", false);
    series.ticks.template.set("visible", false);

    // Customize slices
    series.slices.template.setAll({
      fillOpacity: 0.9,
      strokeOpacity: 0,
    });

    // Create legend
    let legend = chart.children.push(
      am5.Legend.new(root, {
        centerX: am5.percent(100),
        x: am5.percent(100),
      })
    );

    // Link legend to the series
    legend.data.setAll(series.dataItems);

    // Customize legend markers
    legend.markers.template.setAll({
      width: 15,
      height: 15,
      borderRadius: 10,
    });

    legend.labels.template.setAll({
      text: "{category}",
    });

    // Play initial series animation
    series.appear(1000, 100);

    return () => {
      root.dispose();
    };
  }, [data]);

  return (
    <div id="servicePieChart" style={{ width: "100%", height: "300px" }}></div>
  );
};

export default ServicePieChart;
